// Adaptateurs : convertissent les réponses API dans le format
// attendu par les composants existants (VehicleCard, DossierHero, tabs, etc.).
import { formatFrDate, formatRelative } from "@/lib/format";

// Item de liste (Dashboard)
export const normalizeListItem = (d) => ({
  id: d.id,
  name: d.vehicle_name,
  image: d.vehicle_image,
  orderNumber: d.order_number,
  progress: d.progress,
  availabilityDate: formatFrDate(d.availability_date),
  client: d.client_name,
  commercial: d.commercial_name,
  lastUpdate: formatRelative(d.updated_at),
  currentStatus: d.current_status, // {label, color}
  isFinished: d.is_finished,
});

// Détail complet (DossierDetail)
export const normalizeDetail = (d) => ({
  id: d.id,
  name: d.vehicle_name,
  image: d.vehicle_image,
  orderNumber: d.order_number,
  accessCode: d.access_code,
  progress: d.progress,
  availabilityDate: formatFrDate(d.availability_date),
  availabilityDateRaw: d.availability_date,
  reservationDate: formatFrDate(d.reservation_date),
  client: d.client?.name || "",
  clientEmail: d.client?.email,
  clientPhone: d.client?.phone,
  commercial: d.commercial_name,
  commercialId: d.commercial_id,
  currentStatus: d.current_status,
  isFinished: d.is_finished,
  steps: d.steps || [],
  interventions: d.interventions || [],
  messages: d.messages || [],
  documents: d.documents || [],
  media: d.media || [],
  deliveryDate: formatFrDate(d.delivery_date),
  deliveryDateRaw: d.delivery_date,
  deliveryTime: d.delivery_time,
  deliveryLocation: d.delivery_location,
  createdAt: d.created_at,
  updatedAt: d.updated_at,
  clientAccount: d.client_account || null,
  workflowSummary: d.workflow_summary || null,
  workflowTemplateId: d.workflow_template_id || null,
  workflowSlug: d.workflow_slug || null,
});

// Réécrit une URL /api/files/... vers /api/client/files/... pour l'espace client
// (le cookie client_token est envoyé automatiquement par <img>/<video> sur même origine)
const rewriteClientUrl = (url) => {
  if (!url) return url;
  if (typeof url === "string" && url.startsWith("/api/files/")) {
    return url.replace(/^\/api\/files\//, "/api/client/files/");
  }
  return url;
};

// Détail côté client (vue épurée)
export const normalizeClientDetail = (d) => ({
  id: d.id,
  name: d.vehicle_name,
  image: rewriteClientUrl(d.vehicle_image),
  orderNumber: d.order_number,
  progress: d.progress,
  availabilityDate: formatFrDate(d.availability_date),
  deliveryDate: formatFrDate(d.delivery_date),
  deliveryTime: d.delivery_time || "",
  deliveryLocation: d.delivery_location || "",
  client: d.client?.name || "",
  commercial: d.commercial_name || d.advisor?.name || "",
  currentStatus: d.current_status,
  isFinished: d.is_finished,
  steps: d.steps || [],
  messages: d.messages || [],
  documents: (d.documents || []).map((doc) => ({ ...doc, url: rewriteClientUrl(doc.url) })),
  media: (d.media || []).map((m) => ({ ...m, url: rewriteClientUrl(m.url) })),
  agency: d.agency || null,
  advisor: d.advisor || null,
  workflowSummary: d.workflow_summary || null,
});
